.panel {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1_5);
  padding: var(--tuna-spacing-2);
  min-width: 18rem;
}

.row {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-0_5);
}

.label {
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-palette-text-secondary);
}

.options {
  display: flex;
  flex-wrap: wrap;
  gap: var(--tuna-spacing-0_5);
}

.switchRow {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-1);
  cursor: pointer;
}

/* Perform is used on tablets on stage: every option meets the 44px target (WCAG 2.5.5, Fitts). */
.options > button {
  min-height: 44px;
  min-width: 44px;
}

.switchRow {
  min-height: 44px;
}

/* Phones: "Aa", a 44px target */
.compactTrigger {
  min-width: 44px;
  min-height: 44px;
  font-weight: 600;
}
